module.exports = __webpack_public_path__ + "static/media/symbol-liveplay_white.dbb1cbf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol-liveplay_white.svg
// module id = ./src/assets/images/symbol-liveplay_white.svg
// module chunks = 0